__turbopack_context__.v({
  "button": "WalletItemsEmptyState-module__tIV43q__button",
  "email": "WalletItemsEmptyState-module__tIV43q__email",
  "emailContainer": "WalletItemsEmptyState-module__tIV43q__emailContainer",
  "emptyContainer": "WalletItemsEmptyState-module__tIV43q__emptyContainer",
  "emptyText": "WalletItemsEmptyState-module__tIV43q__emptyText",
  "emptyTitle": "WalletItemsEmptyState-module__tIV43q__emptyTitle",
  "input": "WalletItemsEmptyState-module__tIV43q__input",
  "root": "WalletItemsEmptyState-module__tIV43q__root",
});
